import React, { useState, useEffect } from 'react';
import { getToken } from '../../../../../helpers/Jwt';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from 'axios';
import ActionComponent from '../../../../Activity/Component/ActionComponent';
import PayrollCompnent from './@component/PayrollComponent';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const PATH_PAYROLL = "/api/hrppsu/employee/payroll";

const Section = ({ title, data, isEditing, onEditClick, children }) => (
  <div className='flex mt-5 border-b border-gray-300'>
    <div className='w-1/3'><h2 className='font-bold text-xl'>{title}</h2></div>
    <div className={isEditing ? 'hidden' : 'w-full p-3'}>
      <div className='justify-end flex'>
        <button onClick={onEditClick} className='bg-gray-200 hover:bg-gray-400 text-black py-0 px-4 rounded'>Edit</button>
      </div>
      {data?.map((d, i) => (
        <div key={i} className='flex justify-between'>
          <p className='p-1 text-xs font-bold'>{d.label}</p>
          <p className='p-1 text-xs text-end'>{d.value}</p>
        </div>
      ))}
    </div>
    <div className={!isEditing ? 'hidden' : 'w-full p-3'}>{children}</div>
  </div>
);

const Payroll = ({ id_employee, payroll, bank, onRefresh }) => {
  const [isForm, setIsForm] = useState(false);
  const [isFormBank, setIsFormBank] = useState(false);
  const [isFormPayrollComponent, setIsFormPayrollComponent] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(null);
  const [dataPayrollComponent, setDataPayrollComponent] = useState([]);
  const [optionPayrollComponent, setOptionPayrollComponent] = useState([]);

  const [isPayrollComponentOpen, setPayrollComponentOpen] = useState(true);

  const [loadingPayrollComponent, setLoadingPayrollComponent] = useState(true);
  const [errorPayrollComponent, setErrorPayrollComponent] = useState(null);

  const fetchData = async (url, setLoading, setError) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      setError("Failed to fetch data.");
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      const data = await fetchData(`${BASE_URL}${PATH_PAYROLL}/component?id_employee=${id_employee}`, setLoadingPayrollComponent, setErrorPayrollComponent);
      if (data) setDataPayrollComponent(data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const data = await fetchData(`${BASE_URL}${PATH_PAYROLL}/componentoption`, setLoadingPayrollComponent, setErrorPayrollComponent);
      if (data) setOptionPayrollComponent(data);
    })();
  }, []);

  const handleSubmit = async (values, actions, toggleForm) => {
    try {
      await axios.post(`${BASE_URL}${PATH_PAYROLL}`, { ...values, id_employee }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`
        }
      });
      onRefresh();
      toggleForm(false);
    } catch (err) {
      setErrorSubmit("Gagal menyimpan data. Silakan coba lagi.");
    } finally {
      actions.setSubmitting(false);
    }
  };

  const renderForm = (data, toggleForm) => (
    <Formik
      initialValues={Object.fromEntries(data.map(d => [d.key, d.value]))}
      validationSchema={Yup.object().shape({})}
      onSubmit={(values, actions) => handleSubmit(values, actions, toggleForm)}
      enableReinitialize
    >
      {({ isSubmitting, setFieldValue }) => (
        <Form>
          {data.map((d, i) => (
            <ActionComponent
              key={i}
              callChange={val => setFieldValue(d.key, val)}
              action={{
                element: "input",
                action_attribute: [
                  { key: "type", value: d.type },
                  { key: "name", value: d.key },
                  { key: "placeholder", value: d.label },
                  { key: "className", value: "my-1 p-2 block w-full border border-gray-300 rounded-md" }
                ]
              }}
              defaultValue={d.value}
            />
          ))}
          <div className='flex justify-end mt-5'>
            <button type="button" className='mx-2 bg-gray-200 py-1 px-4 rounded' onClick={() => toggleForm(false)}>Batal</button>
            <button type="submit" disabled={isSubmitting} className='bg-blue-500 text-white py-1 px-4 rounded'>
              {isSubmitting ? 'Menyimpan...' : 'Simpan'}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );

  return (
    <div className='w-full p-5'>
      <h1 className='text-xl font-bold'>Payroll Info</h1>
      {errorSubmit && <p className="bg-red-400 text-white p-2 rounded">Error: {errorSubmit}</p>}

      <PayrollCompnent
        show={isPayrollComponentOpen}
        onClose={() => setPayrollComponentOpen(false)}
        options={optionPayrollComponent}
        apply={(value) => {
          console.log(value);          
        }}
      />

      <Section
        title="Salary"
        data={payroll}
        isEditing={isForm}
        onEditClick={() => setIsForm(true)}
      >
        {renderForm(payroll, setIsForm)}
      </Section>

      <Section
        title="Bank Information"
        data={bank}
        isEditing={isFormBank}
        onEditClick={() => setIsFormBank(true)}
      >
        {renderForm(bank, setIsFormBank)}
      </Section>

      <Section
        title="Payroll Component"
        data={dataPayrollComponent}
        isEditing={isFormPayrollComponent}
        onEditClick={() => setIsFormPayrollComponent(true)}
      >
        <div className='justify-end flex'>
          <button type="button" className='mx-2 bg-gray-200 py-1 px-2 rounded' onClick={() => setPayrollComponentOpen(true)}>Tambah Payroll Component</button>
        </div>
        {renderForm(dataPayrollComponent, setIsFormPayrollComponent)}
      </Section>

      
    </div>
  );
};

export default Payroll;